import { render, staticRenderFns } from "./CashPaymentSubmission.vue?vue&type=template&id=c28335f4&"
import script from "./CashPaymentSubmission.vue?vue&type=script&lang=js&"
export * from "./CashPaymentSubmission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports